import { Dispatch, SetStateAction, useState } from 'react';
import { createContainer } from 'unstated-next';
import { atom } from 'recoil';

import type { IDataSourceAccounts } from '../views/datasources/datasources';
import { CHANNELS_BY_GROUP, CHANNEL_GROUP } from '../constants';
import socialsList from '../components/provider-list/constants';
import { newDatasource } from '../views/add-data-source/constant';
import { CHANNEL } from '../constants/types';

interface IChannels {
  [x: string]: (
    | {
        logo: string;
        provider: string;
        isDisabled: boolean;
        displayName: string;
        hintElement?: undefined;
      }
    | {
        logo: string;
        provider: string;
        isDisabled: boolean;
        displayName: string;
        hintElement: JSX.Element;
      }
  )[];
}

export interface IAddDataSource {
  isOpen: boolean;
  handleCloseModal: (provider?: CHANNEL, displayName?: string) => void;
  setShowSettings: Dispatch<SetStateAction<boolean>>;
  currentPage: string;
  currentStep: string;
  setCurrentStep: Dispatch<SetStateAction<string>>;
  setCurrentPage: Dispatch<SetStateAction<string>>;
  provider: CHANNEL | undefined;
  addButtonStatus: boolean;
  selectedSubAccount: IDataSourceAccounts<any> | undefined;
  setSelectedSubAccount: Dispatch<
    SetStateAction<IDataSourceAccounts<any> | undefined>
  >;
  setAddButtonStatus: Dispatch<SetStateAction<boolean>>;
  selectedDataSource: IDataSourceAccounts<any> | undefined;
  setSelectedDatasource: Dispatch<
    SetStateAction<IDataSourceAccounts<any> | undefined>
  >;
  handleSetcurrentSelectedPage: (
    selectedPage: IDataSourceAccounts<any>
  ) => void;
  client: IDataSourceAccounts<any> | undefined;
  currentDataSourceName: string;
  datasourceProvider: IChannels[];
  searchTxt: string;
  handeSearchChange: (value: string) => void;
  activation: boolean;
  setActivation: Dispatch<SetStateAction<boolean>>;
}

const showSocials = Object.keys(CHANNELS_BY_GROUP).map(channel => {
  const filterData = socialsList.filter(socials => {
    if (channel !== CHANNEL_GROUP.all) {
      return CHANNELS_BY_GROUP[channel].includes(socials.provider);
    }
    return '';
  });
  return { [channel]: filterData };
});

showSocials.splice(showSocials.length - 2, 2);

const channelsCategory = ['social', 'ads', 'emails', 'website', 'coming soon'];

export const AddonClientId = atom<string>({
  key: 'addon-client-id',
  default: '',
});

const useAddDataSourceHook = (): IAddDataSource => {
  const [activation, setActivation] = useState<boolean>(false);
  const [searchTxt, setSearchTxt] = useState<string>('');
  const [datasourceProvider, setDatasourceProvider] = useState<IChannels[]>(
    showSocials as IChannels[]
  );
  const [showSettings, setShowSettings] = useState<boolean>(false);
  const [addButtonStatus, setAddButtonStatus] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState(
    newDatasource.SELECT_DATASOURCE
  );
  const [currentDataSourceName, setCurrentDataSourceName] = useState<string>(
    ''
  );
  const [selectedDataSource, setSelectedDatasource] = useState<
    IDataSourceAccounts<any>
  >();
  const [selectedSubAccount, setSelectedSubAccount] = useState<
    IDataSourceAccounts<any>
  >();
  const [currentDataSource, setCurrentDataSource] = useState<
    CHANNEL | undefined
  >();
  const [currentStep, setCurrentStep] = useState<string>('');

  const handleCloseModal = (provider?: CHANNEL, displayName?: string) => {
    if (provider && displayName) {
      setCurrentDataSource(provider);
      setCurrentDataSourceName(displayName);
    }
    setCurrentPage(newDatasource.SELECT_DATASOURCE);
    setShowSettings(!showSettings);
    setSelectedDatasource({} as any);
  };

  const handleSetcurrentSelectedPage = (
    selectedPage: IDataSourceAccounts<any>
  ) => {
    setSelectedDatasource(selectedPage);
  };

  const handeSearchChange = (value: string) => {
    setSearchTxt(value);
    if (value === '') {
      setDatasourceProvider(showSocials as IChannels[]);
    } else {
      const filteredDataSources = showSocials.map((dataSource, idx) => {
        const filter = dataSource[
          channelsCategory[idx]
        ]?.filter(channelSource =>
          channelSource.provider
            .trim()
            .toLowerCase()
            .includes(value.trim().toLowerCase())
        );
        if (filter?.length > 0) {
          return { [channelsCategory[idx]]: filter };
        }
        return null;
      });
      const checkNullData =
        filteredDataSources?.filter(data => data !== null) ?? [];
      setDatasourceProvider(checkNullData as IChannels[]);
    }
  };

  return {
    selectedSubAccount,
    setSelectedSubAccount,
    addButtonStatus,
    setAddButtonStatus,
    currentPage,
    client: selectedDataSource,
    currentDataSourceName,
    currentStep,
    handleCloseModal,
    handleSetcurrentSelectedPage,
    isOpen: showSettings,
    provider: currentDataSource,
    selectedDataSource,
    setSelectedDatasource,
    setCurrentPage,
    setCurrentStep,
    setShowSettings,
    datasourceProvider,
    searchTxt,
    handeSearchChange,
    activation,
    setActivation,
  };
};

const AddDataSourceContainer = createContainer(useAddDataSourceHook);

export default AddDataSourceContainer;
